import React, { FC, memo } from 'react';
import { Text, View } from '@react-pdf/renderer';

import { BASE_FONT_SIZE } from '../pdfStyles';
import { TravelFilePassengerFlatten } from '../../../routes/Reservations/TravelFile/TravelFileHomePage/PassengersSection/PassengersSection';

type Props = {
    passenger: TravelFilePassengerFlatten & { name: string; title?: string; city?: string; postalCode?: string };
    withoutTo?: boolean;
};

const PdfPassengerDetails: FC<Props> = (props: Props) => {
    const { passenger, withoutTo } = props;

    if (!passenger) {
        return <View />;
    }

    // Build full name — avoid duplicating title if name already starts with it
    const nameStartsWithTitle = passenger.title && passenger.name?.startsWith(passenger.title);
    const displayName = nameStartsWithTitle ? passenger.name : [passenger.title, passenger.name].filter(Boolean).join(' ');

    // Build address line: street + house number
    const addressLine = String(passenger.address ?? '').trim();
    // City + postal code on same line
    const cityLine = [passenger.city, passenger.postalCode].filter(Boolean).map(s => (s || '').trim()).filter(Boolean).join(' ');
    const countryLine = String(passenger.country ?? '').trim();
    // Stored either as { number } or as plain text — the Hebrew receipt already reads both
    const phoneRaw: any = (passenger as any).phone;
    const phone = String((phoneRaw && typeof phoneRaw === 'object' ? phoneRaw.number : phoneRaw) ?? '').trim();

    return (
        <View style={{ marginBottom: 4 }}>
            {!withoutTo ? (
                <Text style={{ fontSize: BASE_FONT_SIZE - 1, color: '#888', marginBottom: 2 }}>To:</Text>
            ) : <></>}
            <Text style={{ fontWeight: 'bold', fontSize: BASE_FONT_SIZE + 1, marginBottom: 2 }}>
                {displayName}
            </Text>
            {addressLine ? (
                <Text style={{ fontSize: BASE_FONT_SIZE, color: '#555' }}>{addressLine}</Text>
            ) : null}
            {cityLine ? (
                <Text style={{ fontSize: BASE_FONT_SIZE, color: '#555' }}>{cityLine}</Text>
            ) : null}
            {countryLine ? (
                <Text style={{ fontSize: BASE_FONT_SIZE, color: '#555' }}>{countryLine}</Text>
            ) : null}
            {phone ? (
                <View style={{ flexDirection: 'row', marginTop: 2 }}>
                    <Text style={{ fontSize: BASE_FONT_SIZE, color: '#777', width: 45 }}>Phone:</Text>
                    <Text style={{ fontSize: BASE_FONT_SIZE }}>{phone}</Text>
                </View>
            ) : null}
        </View>
    );
};

export default memo(PdfPassengerDetails);
